import { jsx as _jsx } from "react/jsx-runtime";
import { useDispatch, useSelector } from 'react-redux';
import { wishListActions } from '../../../redux/wishList/actions/WishListActions.creators';
import { makeGetProductColorIsInWishList } from '../../../redux/wishList/selectors/WishListSelectors';
import { AddToWishlistButton } from '../add-to-wishlist-button/AddToWishlistButton';
export const ProductMediaWishListButton = ({ wishListProduct }) => {
    const productColorIsInWishList = useSelector(makeGetProductColorIsInWishList());
    const dispatch = useDispatch();
    const handleToggleWishlist = () => {
        dispatch(wishListActions.toggleProduct(wishListProduct));
    };
    return (_jsx(AddToWishlistButton, { isProductInWishList: productColorIsInWishList, onToggle: handleToggleWishlist, wishListProduct: wishListProduct }));
};
